import React from 'react';

import RegisterImeiForm from '../components/register-imei-form';

const ImeiRegistration: React.FC = () => (
  <RegisterImeiForm />
);

export default ImeiRegistration;
